import { connect } from 'react-redux';

import { INotification } from 'CorePackage/NotificationModule/interfaces/INotification';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';
import { getNotices } from 'CorePackage/NotificationModule/reducers/noticeReducer';

import { Notification } from './Notification';
import styles from './Notifier.module.scss';

interface INotifierProps {
  notifications: INotification[];
}

const NotifierWithoutStore = ({ notifications }: INotifierProps) => (
  <div className={styles.Wrapper}>
    {notifications.map(notice => (
      <Notification key={notice.id} notice={notice} />
    ))}
  </div>
);

const mapStateToProps = (state: IRootState) => ({
  notifications: getNotices(state),
});

export const Notifier = connect(mapStateToProps)(NotifierWithoutStore);
